import {h, Fragment} from "preact"
import { useProductFilters } from '@nosto/preact'

export default ({ inSidebar }) => {
    const { filters, removeAll } = useProductFilters()
    const sidebarClass = inSidebar ? 'sec-sidebar' : '';

    return filters.length > 0 &&
        <div class={`plp-active-filters ${sidebarClass}`}>
            {
                filters.map(filter => (
                    <button onClick={() => filter.remove()} class='plp-active-filter'>
                        <span class='text-neutral-600'>{filter.value}</span>
                        <span
                            class="plp-active-filter__remove"
                        >
                            ×
                        </span>

                    </button>
                ))
            }
            <button
                class="plp-filters-remove-all link"
                onClick={() => {
                    removeAll()
                }}
            >
                Clear All Filters
            </button>
        </div>
}
